module.exports = __webpack_public_path__ + "img/down-money.3ffa67b6.png";